import { StargateStaticRoutes } from 'core/use-cases/settings/slice/static-routes';
import { StackNavigatorProvider } from 'ui/components';
import { NavigateSetter } from 'ui/components/History';
import { Notification } from 'ui/containers';

import { SectionBuilder } from '../SectionBuilder';
import {
  useComboApplicationWrapper,
  useRedirectBlockedUser,
  useEventResellerId,
  useTapume,
  useLogoutApplicationWrapper,
  useSyncAppRouter,
  useUserRequest,
} from './hooks';

const basePaths = Object.values(StargateStaticRoutes).map((route) => route.path);

const ApplicationWrapper = ({
  children,
  isSearch,
  isStargate,
}: {
  children: JSX.Element;
  isSearch?: boolean;
  isStargate?: boolean;
}) => {
  useUserRequest(isSearch, isStargate);
  useLogoutApplicationWrapper();
  useRedirectBlockedUser();
  useEventResellerId();
  useTapume();
  useComboApplicationWrapper();
  useSyncAppRouter(basePaths);

  const showStackNavigator = isStargate;
  const showNotification = isStargate;
  const showNavigateSetter = isStargate;

  return (
    <>
      {children}
      {showNavigateSetter && <NavigateSetter />}
      {showStackNavigator && (
        <StackNavigatorProvider>
          <SectionBuilder />
        </StackNavigatorProvider>
      )}
      {showNotification && <Notification />}
    </>
  );
};

export default ApplicationWrapper;
